<pw-progress-bar *ngIf="totalQuantity >0"></pw-progress-bar>
<div class="contact-content">
    <div class="contact-form">
        <h3>{{"shoppingCart.personalDatasUpperCase" | translate}}</h3>
        <div class="payment-wrapper-company">
            <div class="payment-input">
                <div class="radio-container">
                    <input (click)="companyOrNot()" type="radio" name="radio-button" />
                    <h4>{{"shoppingCart.company" | translate}}</h4>
                </div>
            </div>
            <div class="payment-input">
                <div class="radio-container">
                    <input (click)="individual()" type="radio" name="radio-button" checked />
                    <h4>{{"shoppingCart.individual" | translate}}</h4>
                </div>
            </div>
        </div>
        <form [formGroup]="contactForm!" novalidate *ngIf="isIndividual">
            <input
                [(ngModel)]="personalData!.email!"
                formControlName="email"
                placeholder="{{ 'contact.email' | translate }}*"
                id="email"
                class="form-control"
                type="email"
                required
                [ngStyle]="contactForm!.controls['email'].invalid && (contactForm!.controls['email'].dirty || contactForm!.controls['email'].touched) && contactForm!.controls['email'].errors?.['required'] && {'border':'1px solid red'}"
                autofocus
            /><br />

            <div
                *ngIf="contactForm!.controls['email'].invalid && (contactForm!.controls['email'].dirty || contactForm!.controls['email'].touched)"
                class="alert-email"
            >
                <div *ngIf="contactForm!.controls['email'].errors?.['required']">
                    <span>{{ 'contact.emailRequired' | translate }}</span>
                </div>
                <span class="text-danger" *ngIf="contactForm!.get('email')!.hasError('pattern')">
                    Helyes email formátum: "info@gmail.com".
                </span>
            </div>

            <br />
            <div class="name">
                <div class="last-name">
                    <input
                        [(ngModel)]="personalData!.lastName!"
                        placeholder="{{ 'contact.lastName' | translate }}*"
                        formControlName="lastName"
                        id="lastName"
                        class="form-control"
                        type="text"
                        required
                        [ngStyle]="contactForm!.controls['lastName'].invalid && (contactForm!.controls['lastName'].dirty || contactForm!.controls['lastName'].touched) && contactForm!.controls['lastName'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactForm!.controls['lastName'].invalid && (contactForm!.controls['lastName'].dirty || contactForm!.controls['lastName'].touched)"
                        class="alert-name"
                    >
                        <div *ngIf="contactForm!.controls['lastName'].errors?.['required']">
                            <span>{{ 'contact.lastNameRequired' | translate }}</span>
                        </div>
                    </div>

                    <br />
                </div>
                <div class="first-name">
                    <input
                        [(ngModel)]="personalData!.firstName!"
                        placeholder="{{ 'contact.firstName' | translate }}*"
                        formControlName="firstName"
                        id="firstName"
                        class="form-control"
                        type="text"
                        required
                        [ngStyle]="contactForm!.controls['firstName'].invalid && (contactForm!.controls['firstName'].dirty || contactForm!.controls['firstName'].touched) && contactForm!.controls['firstName'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactForm!.controls['firstName'].invalid && (contactForm!.controls['firstName'].dirty || contactForm!.controls['firstName'].touched)"
                        class="alert-name"
                    >
                        <div *ngIf="contactForm!.controls['firstName'].errors?.['required']">
                            <span>{{ 'contact.firstNameRequired' | translate }}</span>
                        </div>
                    </div>

                    <br />
                </div>
            </div>
            <div class="input-phone">
                <div class="phone-label">
                    <label>{{hungarianPhonePrefix}}</label>
                </div>
                <div class="phone-number">
                    <input
                        [(ngModel)]="personalData!.phoneNumber"
                        formControlName="phoneNumber"
                        placeholder="{{ 'contact.phoneNumber' | translate }}*"
                        id="phoneNumber"
                        class="form-control"
                        type="text"
                        required
                        [ngStyle]="contactForm!.controls['phoneNumber'].invalid && (contactForm!.controls['phoneNumber'].dirty || contactForm!.controls['phoneNumber'].touched) && contactForm!.controls['phoneNumber'].errors?.['required'] && {'border':'1px solid red'}"
                        autofocus
                    /><br />
                </div>
            </div>
            <div
                *ngIf="contactForm!.controls['phoneNumber'].invalid && (contactForm!.controls['phoneNumber'].dirty || contactForm!.controls['phoneNumber'].touched)"
                class="alert-phoneNumber"
            >
                <div *ngIf="contactForm!.controls['phoneNumber'].errors?.['required']">
                    <span>{{ 'contact.phoneNumberRequired' | translate }}</span>
                </div>
                <span class="text-danger" *ngIf="contactForm!.get('phoneNumber')!.hasError('pattern')">
                    Rossz telefonszám formátum!
                </span>
            </div>

            <br />
            <div class="zip-settlement-container">
                <div class="zip">
                    <input
                        [(ngModel)]="personalData!.zipCode"
                        #zip
                        (keyup)="loadCity(zip.value)"
                        placeholder="{{ 'contact.zipcode' | translate }}*"
                        type="number"
                        formControlName="zipCode"
                        id="zipCode"
                        class="form-control"
                        required
                        [ngStyle]="contactForm!.controls['zipCode'].invalid && (contactForm!.controls['zipCode'].dirty || contactForm!.controls['zipCode'].touched) && contactForm!.controls['zipCode'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactForm!.controls['zipCode'].invalid && (contactForm!.controls['zipCode'].dirty || contactForm!.controls['zipCode'].touched)"
                        class="alert-zipCode"
                    >
                        <div *ngIf="contactForm!.controls['zipCode'].errors?.['required']">
                            <span>{{"contact.zipRequired" | translate }}</span>
                        </div>
                        <span class="text-danger" *ngIf="contactForm!.get('zipCode')!.hasError('pattern')">
                            Helyes irányítószám: "1234" - négy darab számjegy.
                        </span>
                    </div>
                    <br />
                </div>
                <div class="settlement">
                    <input
                        [(ngModel)]="cityName"
                        placeholder="{{ 'contact.settlement' | translate }}*"
                        type="text"
                        formControlName="settlement"
                        id="settlement"
                        class="form-control"
                        required
                        [ngStyle]="contactForm!.controls['settlement'].invalid && (contactForm!.controls['settlement'].dirty || contactForm!.controls['settlement'].touched) && contactForm!.controls['settlement'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactForm!.controls['settlement'].invalid && (contactForm!.controls['settlement'].dirty || contactForm!.controls['settlement'].touched)"
                        class="alert-settlement"
                    >
                        <div *ngIf="contactForm!.controls['settlement'].errors?.['required']">
                            <span>{{ 'contact.cityRequired' | translate }}</span>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
            <input
                [(ngModel)]="personalData!.address"
                placeholder="{{ 'contact.address' | translate }}*"
                type="text"
                formControlName="address"
                id="address"
                class="form-control"
                required
                [ngStyle]="contactForm!.controls['address'].invalid && (contactForm!.controls['address'].dirty || contactForm!.controls['address'].touched) && contactForm!.controls['address'].errors?.['required'] && {'border':'1px solid red'}"
            /><br />

            <div
                *ngIf="contactForm!.controls['address'].invalid && (contactForm!.controls['address'].dirty || contactForm!.controls['address'].touched)"
                class="alert-address"
            >
                <div *ngIf="contactForm!.controls['address'].errors?.['required']">
                    <span>{{ 'contact.addressRequired' | translate }}</span>
                </div>
            </div>
            <br />
            <label>{{ 'contact.markedRequired' | translate }}</label><br /><br />
        </form>

        <form [formGroup]="contactFormCompany!" novalidate *ngIf="isCompany">
            <input
                [(ngModel)]="personalData!.companyName"
                formControlName="companyName"
                placeholder="{{ 'contact.companyName' | translate }}*"
                type="text"
                id="companyName"
                class="form-control"
                required
                [ngStyle]="contactFormCompany!.controls['companyName'].invalid && (contactFormCompany!.controls['companyName'].dirty || contactFormCompany!.controls['companyName'].touched) && contactFormCompany!.controls['companyName'].errors?.['required'] && {'border':'1px solid red'}"
            /><br />

            <div
                *ngIf="contactFormCompany!.controls['companyName'].invalid && (contactFormCompany!.controls['companyName'].dirty || contactFormCompany!.controls['companyName'].touched)"
                class="alert-compName"
            >
                <div *ngIf="contactFormCompany!.controls['companyName'].errors?.['required']">
                    <span>{{ 'contact.companyNameRequired' | translate }}</span>
                </div>
            </div>
            <br />
            <div class="name">
                <div class="last-name">
                    <input
                        [(ngModel)]="personalData!.lastName!"
                        placeholder="{{ 'contact.lastName' | translate }}*"
                        formControlName="lastName"
                        id="lastName"
                        class="form-control"
                        type="text"
                        required
                        [ngStyle]="contactFormCompany!!.controls['lastName'].invalid && (contactFormCompany!!.controls['lastName'].dirty || contactFormCompany!!.controls['lastName'].touched) && contactFormCompany!!.controls['lastName'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactFormCompany!!.controls['lastName'].invalid && (contactFormCompany!!.controls['lastName'].dirty || contactFormCompany!!.controls['lastName'].touched)"
                        class="alert-name"
                    >
                        <div *ngIf="contactFormCompany!!.controls['lastName'].errors?.['required']">
                            <span>{{ 'contact.lastNameRequired' | translate }}</span>
                        </div>
                    </div>

                    <br />
                </div>
                <div class="first-name">
                    <input
                        [(ngModel)]="personalData!.firstName!"
                        placeholder="{{ 'contact.firstName' | translate }}*"
                        formControlName="firstName"
                        id="firstName"
                        class="form-control"
                        type="text"
                        required
                        [ngStyle]="contactFormCompany!!.controls['firstName'].invalid && (contactFormCompany!!.controls['firstName'].dirty || contactFormCompany!!.controls['firstName'].touched) && contactFormCompany!!.controls['firstName'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactFormCompany!!.controls['firstName'].invalid && (contactFormCompany!!.controls['firstName'].dirty || contactFormCompany!!.controls['firstName'].touched)"
                        class="alert-name"
                    >
                        <div *ngIf="contactFormCompany!!.controls['firstName'].errors?.['required']">
                            <span>{{ 'contact.firstNameRequired' | translate }}</span>
                        </div>
                    </div>

                    <br />
                </div>
            </div>
            <input
                [(ngModel)]="personalData!.email"
                formControlName="companyEmail"
                placeholder="{{ 'contact.email' | translate }}*"
                type="email"
                id="companyEmail"
                class="form-control"
                required
                [ngStyle]="contactFormCompany!.controls['companyEmail'].invalid && (contactFormCompany!.controls['companyEmail'].dirty || contactFormCompany!.controls['companyEmail'].touched) && contactFormCompany!.controls['companyEmail'].errors?.['required'] && {'border':'1px solid red'}"
            /><br />

            <div
                *ngIf="contactFormCompany!.controls['companyEmail'].invalid && (contactFormCompany!.controls['companyEmail'].dirty || contactFormCompany!.controls['companyEmail'].touched)"
                class="alert-companyEmail"
            >
                <div *ngIf="contactFormCompany!.controls['companyEmail'].errors?.['required']">
                    <span>{{ 'contact.emailRequired' | translate }}</span>
                </div>
                <span class="text-danger" *ngIf="contactFormCompany!.get('companyEmail')!.hasError('pattern')">
                    Helyes email formátum: "info@gmail.com".
                </span>
            </div>
            <br />
            <div class="input-phone">
                <div class="phone-label">
                    <label>{{hungarianPhonePrefix}}</label>
                </div>
                <div class="phone-number">
                    <input
                        [(ngModel)]="personalData!.phoneNumber"
                        formControlName="phoneNumber"
                        placeholder="{{ 'contact.phoneNumber' | translate }}*"
                        id="phoneNumber"
                        class="form-control"
                        type="text"
                        required
                        [ngStyle]="contactFormCompany!.controls['phoneNumber'].invalid && (contactFormCompany!.controls['phoneNumber'].dirty || contactFormCompany!.controls['phoneNumber'].touched) && contactFormCompany!.controls['phoneNumber'].errors?.['required'] && {'border':'1px solid red'}"
                        autofocus
                    /><br />
                </div>
            </div>
            <div
                *ngIf="contactFormCompany!.controls['phoneNumber'].invalid && (contactFormCompany!.controls['phoneNumber'].dirty || contactFormCompany!.controls['phoneNumber'].touched)"
                class="alert-phoneNumber"
            >
                <div *ngIf="contactFormCompany!.controls['phoneNumber'].errors?.['required']">
                    <span>{{ 'contact.phoneNumberRequired' | translate }}</span>
                </div>
                <span class="text-danger" *ngIf="contactFormCompany!.get('phoneNumber')!.hasError('pattern')">
                    Rossz telefonszám formátum!
                </span>
            </div>
            <br />
            <input
                [(ngModel)]="personalData!.taxNumber"
                formControlName="vatNumber"
                placeholder="{{ 'contact.vatNumber' | translate }}*"
                type="text"
                id="vatNumber"
                class="form-control"
                required
                [ngStyle]="contactFormCompany!.controls['vatNumber'].invalid && (contactFormCompany!.controls['vatNumber'].dirty || contactFormCompany!.controls['vatNumber'].touched) && contactFormCompany!.controls['vatNumber'].errors?.['required'] && {'border':'1px solid red'}"
            /><br />

            <div
                *ngIf="contactFormCompany!.controls['vatNumber'].invalid && (contactFormCompany!.controls['vatNumber'].dirty || contactFormCompany!.controls['vatNumber'].touched)"
                class="alert-vatNumber"
            >
                <div *ngIf="contactFormCompany!.controls['vatNumber'].errors?.['required']">
                    <span>{{ 'contact.vatRequired' | translate }}</span>
                </div>
            </div>
            <br />
            <div class="zip-settlement-container">
                <div class="zip">
                    <input
                        [(ngModel)]="personalData!.zipCode"
                        #zip
                        (keyup)="loadCity(zip.value)"
                        placeholder="{{ 'contact.zipcode' | translate }}*"
                        type="number"
                        formControlName="companyZipCode"
                        id="companyZipCode"
                        class="form-control"
                        required
                        [ngStyle]="contactFormCompany!.controls['companyZipCode'].invalid && (contactFormCompany!.controls['companyZipCode'].dirty || contactFormCompany!.controls['companyZipCode'].touched) && contactFormCompany!.controls['companyZipCode'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactFormCompany!.controls['companyZipCode'].invalid && (contactFormCompany!.controls['companyZipCode'].dirty || contactFormCompany!.controls['companyZipCode'].touched)"
                        class="alert-companyZipCode"
                    >
                        <div *ngIf="contactFormCompany!.controls['companyZipCode'].errors?.['required']">
                            <span>{{"contact.zipRequired" | translate }}</span>
                        </div>
                        <span class="text-danger" *ngIf="contactFormCompany!.get('companyZipCode')!.hasError('pattern')">
                            Helyes irányítószám: "1234" - négy darab számjegy.
                        </span>
                    </div>
                    <br />
                </div>
                <div class="settlement">
                    <input
                        [(ngModel)]="cityName"
                        placeholder="{{ 'contact.settlement' | translate }}*"
                        type="text"
                        formControlName="companySettlement"
                        id="companySettlement"
                        class="form-control"
                        required
                        [ngStyle]="contactFormCompany!.controls['companySettlement'].invalid && (contactFormCompany!.controls['companySettlement'].dirty || contactFormCompany!.controls['companySettlement'].touched) && contactFormCompany!.controls['companySettlement'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactFormCompany!.controls['companySettlement'].invalid && (contactFormCompany!.controls['companySettlement'].dirty || contactFormCompany!.controls['companySettlement'].touched)"
                        class="alert-companySettlement"
                    >
                        <div *ngIf="contactFormCompany!.controls['companySettlement'].errors?.['required']">
                            <span>{{ 'contact.cityRequired' | translate }}</span>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
            <input
                [(ngModel)]="personalData!.address"
                placeholder="{{ 'contact.address' | translate }}*"
                type="text"
                formControlName="companyAddress"
                id="companyAddress"
                class="form-control"
                required
                [ngStyle]="contactFormCompany!.controls['companyAddress'].invalid && (contactFormCompany!.controls['companyAddress'].dirty || contactFormCompany!.controls['companyAddress'].touched) && contactFormCompany!.controls['companyAddress'].errors?.['required'] && {'border':'1px solid red'}"
            /><br />

            <div
                *ngIf="contactFormCompany!.controls['companyAddress'].invalid && (contactFormCompany!.controls['companyAddress'].dirty || contactFormCompany!.controls['companyAddress'].touched)"
                class="alert-companyAddress"
            >
                <div *ngIf="contactFormCompany!.controls['companyAddress'].errors?.['required']">
                    <span>{{ 'contact.addressRequired' | translate }}</span>
                </div>
            </div>
            <br />
            <label>{{ 'contact.markedRequired' | translate }}</label><br /><br />
        </form>
    </div>
    <div *ngIf="!isTokenExists" class="want-to-register-container">
        <div class="want-to-register">
            <form [formGroup]="form!">
                <section (click)="wantToRegister()" class="example-section">
                    <mat-checkbox formControlName="updates" class="example-margin" [checked]="wantToSignup"
                        >{{"contact.wantToRegister" | translate}}</mat-checkbox
                    >
                </section>
            </form>
        </div>
    </div>
    <div *ngIf="wantToSignup" class="signup-password-main">
        <div class="signup-password-popup">
            <div class="signup-popup">
                <div class="title-container">
                    <div class="title">
                        <h3>{{"contact.addPassword" | translate | uppercase}}</h3>
                    </div>
                </div>
                <form [formGroup]="registrationForm!">
                    <div class="username-password">
                        <div class="password-container">
                            <div class="password">
                                <label>{{'login.password' | translate}}</label>
                                <input
                                    formControlName="password"
                                    id="password"
                                    class="form-control"
                                    required
                                    [ngStyle]="registrationForm!.controls['password'].invalid && (registrationForm!.controls['password'].dirty ||registrationForm!.controls['password'].touched) && registrationForm!.controls['password'].errors?.['required'] && {'border':'1px solid red'}"
                                    autofocus
                                    type="password"
                                /><br />
                                <div
                                    *ngIf="registrationForm!.controls['password'].invalid && (registrationForm!.controls['password'].dirty || registrationForm!.controls['password'].touched)"
                                    class="alert-password"
                                >
                                    <div *ngIf="registrationForm!.controls['password'].errors?.['required']">
                                        <small>{{ 'login.passwordRequired' | translate }}</small>
                                    </div>
                                    <small class="text-danger" *ngIf="registrationForm!.get('password')!.hasError('pattern')">
                                        A jelszónak tartalmaznia kell kis-és nagybetűt és számot! '%' jelet nem.
                                    </small>
                                </div>
                                <br />
                            </div>
                            <div class="password-confirm">
                                <label>{{'login.passwordConfirm' | translate}}</label>
                                <input
                                    formControlName="passwordConfirm"
                                    id="passwordConfirm"
                                    class="form-control"
                                    required
                                    [ngStyle]="registrationForm!.controls['passwordConfirm'].invalid && (registrationForm!.controls['passwordConfirm'].dirty ||registrationForm!.controls['passwordConfirm'].touched) && registrationForm!.controls['passwordConfirm'].errors?.['required'] && {'border':'1px solid red'}"
                                    autofocus
                                    type="password"
                                /><br />
                                <div
                                    *ngIf="registrationForm!.controls['passwordConfirm'].invalid && (registrationForm!.controls['passwordConfirm'].dirty || registrationForm!.controls['passwordConfirm'].touched)"
                                    class="alert-password"
                                >
                                    <div *ngIf="registrationForm!.controls['passwordConfirm'].errors?.['required']">
                                        <small>{{ 'login.passwordRequired' | translate }}</small>
                                    </div>
                                </div>
                                <small [ngStyle]="{'color': 'red'}">{{errorMessage}}</small>
                                <br />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div *ngIf="isCompany && !wantToSignup" class="submit-button-container">
        <div class="submit-button">
            <button routerLink="/cartsum" type="submit">{{"shoppingCart.backToCart" | translate}}</button>
            <button (click)="goToDeliveryCompany()" [disabled]="!contactFormCompany?.valid" type="submit">
                {{"shoppingCart.toDelivery" | translate}}
            </button>
        </div>
    </div>
    <div *ngIf="isIndividual && !wantToSignup" class="submit-button-container">
        <div class="submit-button">
            <button routerLink="/cartsum" type="submit">{{"shoppingCart.backToCart" | translate}}</button>
            <button (click)="goToDeliveryIndividual()" [disabled]="!contactForm?.valid" type="submit">
                {{"shoppingCart.toDelivery" | translate}}
            </button>
        </div>
    </div>
    <div *ngIf="isCompany && wantToSignup" class="submit-button-container">
        <div class="submit-button">
            <button routerLink="/cartsum" type="submit">{{"shoppingCart.backToCart" | translate}}</button>
            <button
                (click)="goToDeliveryCompanyRegister()"
                [disabled]="!contactFormCompany?.valid || !registrationForm?.valid"
                type="submit"
            >
                {{"shoppingCart.toDelivery" | translate}}
            </button>
        </div>
    </div>
    <div *ngIf="isIndividual && wantToSignup" class="submit-button-container">
        <div class="submit-button">
            <button routerLink="/cartsum" type="submit">{{"shoppingCart.backToCart" | translate}}</button>
            <button (click)="goToDeliveryIndividualRegister()" [disabled]="!contactForm?.valid || !registrationForm?.valid" type="submit">
                {{"shoppingCart.toDelivery" | translate}}
            </button>
        </div>
    </div>
</div>
